import React from "react"
import SidebarAccordion from "@components/sidebar/accordion"
import Button from "@components/button"
import { showChat } from "../helpers"
import RichText from "@components/rich-text"
import useToggleStates from "@src/hooks/useToggleStates"

const SidebarColumnsInfo = ({ items }) => {
  const [openAccordionIndex, setOpenAccordionIndex] = React.useState(0)
  const { toggleAllFunction } = useToggleStates();

  const handleAccordionClick = index => {
    setOpenAccordionIndex(prevIndex => (prevIndex === index ? null : index))
  }

  const handleButtonClick = (text, internalLink, externalLink) => {
    toggleAllFunction("sidebar");
    if (text.includes("chat") && !internalLink && !externalLink) {
      showChat()
    }
  }

  return (
    <div className="w-full overflow-y-auto">
      {items?.map((item, index) => (
        <SidebarAccordion
          key={index}
          heading={item.title}
          opened={openAccordionIndex === index}
          onAccordionClick={() => handleAccordionClick(index)}
          hasIcon={index === 0 ? false : true}
          isAccordion={{
            desktop: true,
            mobile: true,
          }}
          style={{
            wrapper: "md:w-[518px]",
            title: "",
            content: "!max-h-9999",
          }}
        >
          <div>
            {item.description && openAccordionIndex === index && (
              <RichText
                className="text-lg font-owners font-normal overflow-y-auto"
                text={item.description}
              />
            )}
            {item?.ctaList &&
              openAccordionIndex === index &&
              item.ctaList.map(
                (
                  {
                    theme,
                    themeHover,
                    internalLink,
                    externalLink,
                    text,
                    arrow,
                    ctaWidth,
                  },
                  index
                ) => {
                  return (
                    <div
                      key={index}
                      className="pb-4"
                      onClick={() =>
                        handleButtonClick(text, internalLink, externalLink)
                      }
                    >
                      <Button
                        key={index}
                        theme={theme}
                        themeHover={themeHover}
                        internalLink={internalLink}
                        externalLink={externalLink}
                        arrow={arrow}
                        ctaWidth={ctaWidth}
                        title={text}
                      >
                        {text}
                      </Button>
                    </div>
                  )
                }
              )}
          </div>
        </SidebarAccordion>
      ))}
    </div>
  )
}

export default SidebarColumnsInfo
